import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTopView = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_1233_16387",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 24,
		height: 24,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_1233_16387)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M5.2998 19.9001V18.6001H18.6998V19.9001H5.2998ZM11.9998 16.4538L7.54606 12.0001L8.47481 11.0713L11.3498 13.9463V4.1001H12.6498V13.9463L15.5248 11.0713L16.4536 12.0001L11.9998 16.4538Z",
			fill: "currentColor"
		})
	})]
});
export default SvgTopView;
